import { render, staticRenderFns } from "./hatasayilari.vue?vue&type=template&id=21cd57f0"
import script from "./hatasayilari.vue?vue&type=script&lang=js"
export * from "./hatasayilari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports